import cohort from '../../koa-chansey/cohort'
import { useExperiences } from '../helpers/selectors'

export const pageForUrlEntity = (urlEntity, experiences) => {
  const { link, variants = [], variantFlag } = urlEntity.fields ? urlEntity.fields : urlEntity
  const index = cohort({ experiences }, variantFlag, null)
  const page = (index !== null && variants.length > index) || !link ? variants[index || 0] : link

  return page
}

export const usePageForUrlEntity = (urlEntity) => pageForUrlEntity(urlEntity, useExperiences())
